
export default {
    name: 'BestsellerCard',
    props: {
        card: {type: Object, required: true},
    },
    data() {
        return {selectedId: null};
    },
    computed: {
        selectedProduct() {
            return this.card.variants.find(variant => variant.id === this.selectedId) || this.card.variants[0];
        },
        colorVariants() {
            return this.card.variants.filter(variant => variant.color
                && /^#(?:[a-f\d]{3}|[a-f\d]{6})$/i.test(variant.color.hex_code || ''));
        },
        title() {
            return (this.selectedProduct.name || '').split(/\s+-\s+/)[0];
        },
        colorName() {
            return this.selectedProduct.color ? this.selectedProduct.color.name : '';
        },
        productPath() {
            return `/catalog/product/${this.selectedProduct.alias}/`;
        },
        image() {
            const image = this.selectedProduct.image;
            return image && ((image.sizes && image.sizes.small) || image.path) || '/assets/no_image.jpg';
        },
        image2x() {
            const image = this.selectedProduct.image;
            return image && image.sizes && image.sizes.medium;
        },
        hasDiscount() {
            return Number(this.selectedProduct.price_base) > Number(this.selectedProduct.price);
        },
        currency() {
            return this.$config.siteCountry === 'kz' ? '₸' : '₽';
        },
    },
    methods: {
        formatPrice(price) {
            return new Intl.NumberFormat('ru-RU').format(Number(price));
        },
    },
}
